import { FilterKey } from '@/models/FilterKey';
import Filter from '@/Filter.class';
import { IFilterProvider } from '@/interfaces/filter-providers/IFilterProvider';
import { EventAggregationService } from '@/platform/EventAggregationService';

export default class CertificationTypeFilter extends Filter {
	public constructor(filterProvider: IFilterProvider, eventAggregationService?: EventAggregationService) {
		super(FilterKey.DEGREE_TYPE, filterProvider, eventAggregationService);
	}
}
